import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './ui/CtaButton';
import { bonuses, BONUS_VALUE, CHECKOUT_URL, PRODUCT } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-night" data-id="element-28" data-mp="qt9y1y1a5f7f">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-29" data-mp="qvw6s0zwq0r8">
        <Reveal data-id="element-30" data-mp="14rrinmvw2bl4">
          <SectionHeading id="bonos" tone="dark" eyebrow="Y hoy recibís" title="5 Bonos gratis" description="Estos recursos complementan tu estudio y te ayudan a aprovechar mucho más el Mega Pack." data-id="element-31" data-mp="14rhtu2mkyah0" />
        </Reveal>

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-32" data-mp="19l2pvp4m4udk">
          {bonuses.map((bono, i) => <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col items-center rounded-2xl border border-white/15 bg-white/5 p-7 text-center" data-id="element-33" data-mp="1nhppy0rv40np" data-mpi={i}>
              <span className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.24em] text-gold-bright" data-id="element-34" data-mp="3tr5f3ziek1rd">
                <GiftIcon size={13} data-id="element-35" data-mp="2kulgofq23a2" />
                Bono {i + 1}
              </span>
              <h3 className="mt-3 font-display text-lg font-bold uppercase leading-tight text-white" data-id="element-36" data-mp="7lqkanl7uz8m">
                {bono.title}
              </h3>
              <p className="mt-3 mb-6 text-sm leading-relaxed text-white/75" data-id="element-37" data-mp="chz62jtx5qor">
                {bono.desc}
              </p>
              <div className="mt-auto flex w-full items-center justify-between gap-3 border-t border-white/15 pt-4" data-id="element-38" data-mp="lbloz9d12zgj">
                <span className="text-sm text-white/60 line-through" data-id="element-39" data-mp="qa5c3d3cyhah">
                  Valor {bono.value}
                </span>
                <span className="text-sm font-extrabold uppercase tracking-wide text-gold-bright" data-id="element-40" data-mp="vc4gmqau3k90">
                  Hoy gratis
                </span>
              </div>
            </Reveal>)}

          <Reveal as="li" delay={0.18} className="flex h-full flex-col items-center justify-center rounded-2xl border-2 border-gold-bright bg-gold-bright/10 p-7 text-center" data-id="element-41" data-mp="aliden5u26kj">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-gold-bright" data-id="element-42" data-mp="kcv43bfwaqoz">
              Valor total de los 5 bonos
            </p>
            <p className="mt-2 font-display text-4xl font-bold text-white line-through decoration-danger" data-id="element-43" data-mp="taoy2fq6t88z">
              {BONUS_VALUE}
            </p>
            <p className="mt-3 font-display text-2xl font-bold uppercase text-gold-light" data-id="element-44" data-mp="139wdr9ke9ez9">
              Hoy los 5 son gratis
            </p>
            <p className="mt-3 text-sm leading-relaxed text-white/75" data-id="element-45" data-mp="ybuv2pqvrhob">
              Al adquirir {PRODUCT}, recibís los 5 bonos sin costo adicional.
            </p>
          </Reveal>
        </ul>

        <Reveal delay={0.22} className="mt-10 flex justify-center" data-id="element-46" data-mp="3037ytbh43jis">
          <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-47" data-mp="1fkdxc122132j">
            Quiero mis 5 bonos gratis
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}